export default __webpack_public_path__ + "static/media/webform.2ef0576e.png";